/**
 * @enum {number}
 * @const
 */
var _ol_events_KeyCode_ = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

export default _ol_events_KeyCode_;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/events/keycode.js
// module id = null
// module chunks = 